import { useCallback, useLayoutEffect, useRef } from 'react';

export const useEvent = <T extends (...args: never[]) => unknown>(fn: T) => {
  const fnRef = useRef(fn);

  useLayoutEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  return useCallback((...args: Parameters<T>) => fnRef.current(...args), []);
};
